// The sentence under "Undo this tip?": what reversing one tipping_log row
// does, by where the fruit came from. One copy for the run page and the
// Tipping board, so the two cannot drift.
export function undoTipMessage(t: {
  kind: 'batch' | 'bin' | 'delivery'
  label: string
  bin_quantity: number
  net_weight_kg: number
}): string {
  const kg = Math.round(t.net_weight_kg)
  if (t.kind === 'batch')
    return `Reverses ${t.bin_quantity} crate${t.bin_quantity !== 1 ? 's' : ''} (${kg} kg net) off this run. ${t.label} returns to the Released pool in Force-Cooling. Its release sign-off stands and it can be tipped again.`
  if (t.kind === 'bin')
    return `Reverses bin ${t.label} (${kg} kg net) off this run. A bin that was never placed goes back to the Rebin stock sheet. A placed one returns to the coldroom list without a cell: re-place it before re-tipping. Cannot be undone again.`
  return `Reverses ${t.bin_quantity} bin${t.bin_quantity !== 1 ? 's' : ''} (${kg} kg net) off this run. The source delivery's bins go back into the tip queue. Cannot be undone again.`
}
